import { cn } from '../../lib/utils';
import { PanelTitle } from '../layout/Typography';

export function HowToUseSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <PanelTitle as="h3" size="sm" className="mb-2 font-semibold text-foreground/90">
        {title}
      </PanelTitle>
      {children}
    </div>
  );
}

export function HowToUseSteps({ children }: { children: React.ReactNode }) {
  return <ol className="list-decimal space-y-1 pl-4 text-xs leading-relaxed">{children}</ol>;
}

export function HowToUseStep({ children }: { children: React.ReactNode }) {
  return <li className="pl-0.5">{children}</li>;
}

export function HowToUseBullets({ children }: { children: React.ReactNode }) {
  return <ul className="space-y-1.5 text-xs leading-relaxed">{children}</ul>;
}

export function HowToUseBullet({ children }: { children: React.ReactNode }) {
  return (
    <li className="flex items-start gap-2">
      <span className="mt-1.5 inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-muted-foreground/50" />
      <span>{children}</span>
    </li>
  );
}

export function HowToUseParagraph({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <p className={cn('text-xs leading-relaxed', className)}>{children}</p>;
}

export function HowToUseCode({ children }: { children: React.ReactNode }) {
  return <code className="rounded bg-muted px-1 py-0.5 text-2xs">{children}</code>;
}

export function HowToUseLabel({ children }: { children: React.ReactNode }) {
  return <span className="font-medium text-foreground/70">{children}</span>;
}
